export const BILL_UPLOAD_LOADING = "BILL_UPLOAD_LOADING";
export const BILL_UPLOAD_SUCCESS = "BILL_UPLOAD_SUCCESS";
export const BILL_UPLOAD_ERROR = "BILL_UPLOAD_ERROR";

export const SUBMIT_BILL_LOADING = "SUBMIT_BILL_LOADING";
export const SUBMIT_BILL_SUCCESS = "SUBMIT_BILL_SUCCESS";
export const SUBMIT_BILL_ERROR = "SUBMIT_BILL_ERROR";

export const FETCH_JOB_LOADING = "FETCH_JOB_LOADING ";
export const FETCH_JOB_SUCCESS = "FETCH_JOB_SUCCESS";
export const FETCH_JOB_ERROR = "FETCH_JOB_ERROR";

export const FETCH_JOB_BILL_LOADING = "FETCH_JOB_BILL_LOADING";
export const FETCH_JOB_BILL_SUCCESS = "FETCH_JOB_BILL_SUCCESS";
export const FETCH_JOB_BILL_ERROR = "FETCH_JOB_BILL_ERROR";

export const FETCH_INVOICES_LOADING = "FETCH_INVOICES_LOADING";
export const FETCH_INVOICES_SUCCESS = "FETCH_INVOICES_SUCCESS";
export const FETCH_INVOICES_ERROR = "FETCH_INVOICES_ERROR";

export const FETCH_ERROR_INVOICES_SUCCESS = "FETCH_ERROR_INVOICES_SUCCESS";
export const FETCH_ERROR_INVOICES_ERROR = "FETCH_ERROR_INVOICES_ERROR";

export const DELETE_INVOICE_SUCCESS = "DELETE_INVOICE_SUCCESS";
export const DELETE_INVOICE_ERROR = "DELETE_INVOICE_ERROR";

export const SET_BILL_REDUCER = "SET_BILL_REDUCER";

export const TEST_RESULT_LOADING = "TEST_RESULT_LOADING";
export const TEST_RESULT_SUCCESS = "TEST_RESULT_SUCCESS";
export const TEST_RESULT_ERROR = "TEST_RESULT_ERROR";

export const DOWNLOAD_INVOICE_FILE_LOADING = "DOWNLOAD_INVOICE_FILE_LOADING";
export const DOWNLOAD_INVOICE_FILE = "DOWNLOAD_INVOICE_FILE";
export const DOWNLOAD_INVOICE_SUCCESS = "DOWNLOAD_INVOICE_SUCCESS";

export const GET_DOC_LOADING = "GET_DOC_LOADING";
export const GET_DOC_SUCCESS = "GET_DOC_SUCCESS";
export const GET_DOC_ERROR = "GET_DOC_ERROR";

export const UPDATE_DOC_LOADING = "UPDATE_DOC_LOADING";
export const UPDATE_DOC_SUCCESS = "UPDATE_DOC_SUCCESS";
export const UPDATE_DOC_ERROR = "UPDATE_DOC_ERROR";

export const FETCH_DOC_USERS_SUCCESS = "FETCH_DOC_USERS_SUCCESS";
export const FETCH_DOC_USERS_ERROR = "FETCH_DOC_USERS_ERROR";

export const FETCH_DOC_ITEMS_SUCCESS = "FETCH_DOC_ITEMS_SUCCESS";
export const FETCH_DOC_ITEMS_ERROR = "FETCH_DOC_ITEMS_ERROR";

export const GROUP_DATA_SUCCESS = "GROUP_DATA_SUCCESS";
export const GROUP_DATA_ERROR = "GROUP_DATA_ERROR";

export const UPDATE_DOC_STATUS_LOADING = "UPDATE_DOC_STATUS_LOADING";
export const UPDATE_DOC_STATUS_SUCCESS = "UPDATE_DOC_STATUS_SUCCESS";
export const UPDATE_DOC_STATUS_ERROR = "UPDATE_DOC_STATUS_ERROR";

export const FETCH_USAGE_LOADING = "FETCH_USAGE_LOADING";
export const FETCH_USAGE_SUCCESS = "FETCH_USAGE_SUCCESS";
export const FETCH_USAGE_ERROR = "FETCH_USAGE_ERROR";

export const DOWNLOAD_PRICEBOOK_FILE_LOADING =
  "DOWNLOAD_PRICEBOOK_FILE_LOADING";
export const DOWNLOAD_PRICEBOOK_FILE_ERROR = "DOWNLOAD_PRICEBOOK_FILE_ERROR";
export const DOWNLOAD_PRICEBOOK_SUCCESS = "DOWNLOAD_PRICEBOOK_SUCCESS";

export const FETCH_DOC_JOB_LOADING = "FETCH_DOC_JOB_LOADING ";
export const FETCH_DOC_JOB_SUCCESS = "FETCH_DOC_JOB_SUCCESS";
export const FETCH_DOC_JOB_ERROR = "FETCH_DOC_JOB_ERROR";

export const FETCH_JOB_STAT_LOADING = "FETCH_JOB_STAT_LOADING";
export const FETCH_JOB_STAT_SUCCESS = "FETCH_JOB_STAT_SUCCESS";
export const FETCH_JOB_STAT_ERROR = "FETCH_JOB_STAT_ERROR";

export const GET_VALIDATIONS_LOADING = "GET_VALIDATIONS_LOADING";
export const GET_VALIDATIONS_SUCCESS = "GET_VALIDATIONS_SUCCESS";
export const GET_VALIDATIONS_ERROR = "GET_VALIDATIONS_ERROR";

export const CREATE_PROJECT_LOADING = "CREATE_PROJECT_LOADING";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const CREATE_PROJECT_ERROR = "CREATE_PROJECT_ERROR";

export const DELETE_VALIDATIONS_SUCCESS = "DELETE_VALIDATIONS_SUCCESS";
export const DELETE_VALIDATIONS_ERROR = "DELETE_VALIDATIONS_ERROR";

export const MSME_DATA_LOADING = "MSME_DATA_LOADING";
export const MSME_DATA_SUCCESS = "MSME_DATA_SUCCESS";
export const MSME_DATA_ERROR = "MSME_DATA_ERROR";

export const MSME_ADD_CONV_LOADING = "MSME_ADD_CONV_LOADING";
export const MSME_ADD_CONV_SUCCESS = "MSME_ADD_CONV_SUCCESS";
export const MSME_ADD_CONV_ERROR = "MSME_ADD_CONV_ERROR";

export const MSME_GET_CONV_LOADING = "MSME_GET_CONV_LOADING";
export const MSME_GET_CONV_SUCCESS = "MSME_GET_CONV_SUCCESS";
export const MSME_GET_CONV_ERROR = "MSME_GET_CONV_ERROR";

export const MANUFACTURING_DATA_LOADING = "MANUFACTURING_DATA_LOADING";
export const MANUFACTURING_DATA_SUCCESS = "MANUFACTURING_DATA_SUCCESS";
export const MANUFACTURING_DATA_ERROR = "MANUFACTURING_DATA_ERROR";
export const DELETE_GROUPS_SUCCESS = "DELETE_GROUPS_SUCCESS";
export const DELETE_GROUPS_ERROR = "DELETE_GROUPS_ERROR";

export const HOF_DASHBOARD_SUCCESS = "HOF_DASHBOARD_SUCCESS";
export const HOF_DASHBOARD_ERROR = "HOF_DASHBOARD_ERROR";

export const MARUTI_DASHBOARD_LOADING = "MARUTI_DASHBOARD_LOADING";
export const MARUTI_DASHBOARD_SUCCESS = "MARUTI_DASHBOARD_SUCCESS";
export const MARUTI_DASHBOARD_ERROR = "MARUTI_DASHBOARD_ERROR";
